/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import NotFound from '../components/NotFound';
import { MessageWrapper } from '../components/App/Common/MessageWrapper';
import { Error } from '../components/Error';

const PublicRoute = (props) => {
    // verifyingLogin

  const { WITH_LOGIN, WITH_LOBBY, isLoggedIn } = props;
  const myProps = { ...props, component: WITH_LOGIN ? props.component : NotFound };
  const errorMsg = <Error message="Error en token de acceso" />;

  if (WITH_LOGIN && isLoggedIn && window.route) {
    const to = window.route;
    window.route = undefined;
    return <Redirect to={to} />;
  }


  if ((isLoggedIn || !WITH_LOGIN) && WITH_LOBBY) {
    return <Redirect to="/studies" />;
  }

    return <Route {...myProps} />;
};

export { PublicRoute };
